<div class="flex justify-between items-center w-full h-12">
  <h3 class="df-column-title m-0">
    {{ tacticSettingsService.activeTab?.sectionTitle ?? tacticSettingsService.activeTab?.name }}
  </h3>
  <div><ng-content></ng-content></div>
</div>
